import { FOCUSED_FLOW_CONTENT_MAX_WIDTH_PX } from '@/components/ui/FocusedPageLayout/focusedFlowLayout'

/** The top bar and footer. Matches the measure GM's store widgets share. */
export const WALMART_CHROME_MAX_WIDTH = 1440

/** Storefront pages: a 988px column inside the 16px page gutters. */
export const WALMART_CONTENT_MAX_WIDTH = 1020

/** Flow and auth screens, and any control that would otherwise stretch the full storefront measure. */
export const WALMART_FLOW_MAX_WIDTH = FOCUSED_FLOW_CONTENT_MAX_WIDTH_PX

/** Text blocks sitting inside the storefront measure. Scrolling rows deliberately bleed past it. */
export const WALMART_READING_MAX_WIDTH = FOCUSED_FLOW_CONTENT_MAX_WIDTH_PX

/**
 * Long-form legal / info pages (terms, privacy, notices). Wider than flow screens for
 * multi-column prose, narrower than the full storefront content measure.
 * Matches the common 768px tablet breakpoint.
 */
export const WALMART_LEGAL_MAX_WIDTH = 768

export const WALMART_ACTION_MAX_WIDTH = 320

/** The content wrapper after the top bar; the skip link jumps here. */
export const WALMART_MAIN_CONTENT_ID = 'main-content'

export const WALMART_SERVICE_CARD_MIN_HEIGHT = 233
export const WALMART_PARTNER_CARD_MIN_HEIGHT = 133

export const WALMART_HERO_ASPECT_RATIO = '344 / 127'
export const WALMART_HERO_MAX_HEIGHT = 192

export const WALMART_LOGO_BOX_WIDTH = 137
export const WALMART_LOGO_BOX_HEIGHT = 33

export const WALMART_CAROUSEL_CARD_WIDTH = 252
export const WALMART_PARTNER_OFFER_CARD_LOGO_SIZE = 52
export const WALMART_PARTNER_OFFER_CARD_MIN_HEIGHT = 279

export const WALMART_SERVICE_CARD_WIDTH = 194
export const WALMART_SERVICE_CARD_IMAGE_HEIGHT = 78
export const WALMART_SERVICE_CARD_PADDING = 9
export const WALMART_CARD_ROW_GAP = 16

export const WALMART_ROW_TILE_IMAGE_WIDTH = 124
export const WALMART_ROW_TILE_IMAGE_HEIGHT = 94
export const WALMART_ROW_TILE_ACTION_WIDTH = 200

export const WALMART_PARTNER_MARK_RADIUS = 'var(--gm-radius-round)'

export const WALMART_CHIP_MARK_WIDTH = 36
export const WALMART_CHIP_MARK_HEIGHT = 32
export const WALMART_CHIP_LABEL_WIDTH = 58
export const WALMART_CHIP_LABEL_WIDTH_DESKTOP = 68
export const WALMART_CHIP_WIDTH = 108
export const WALMART_ALL_CHIP_LABEL_WIDTH = 52
export const WALMART_ALL_CHIP_WIDTH = 101
